import React, { memo, ReactNode } from "react";
import classNames from "classnames";
import { useDatePickerContext } from "../DatePickerContext";
import { PredefinedDates } from "../PredefinedDates";

import styles from "./styles.module.scss";

type PropsType = {
  containerClassName?: string,
  children: ReactNode
  footerActions?: ReactNode | ReactNode[]
}

export const CustomContainer = memo(({ children, containerClassName, ...props }: PropsType) => {
  const { selectsRange, predefinedRanges, monthsShown } = useDatePickerContext();
  return (
    <div 
      className={classNames(containerClassName, styles.root, {

      })}
      {...props}
    >
      {
        (selectsRange && predefinedRanges?.length) &&
        <PredefinedDates
          predefinedRanges={predefinedRanges!}
        />
      }
      {/*<div className={classNames(className, styles.internalContent)}>*/}
      <div className={classNames(styles.internalContent, {
        [styles.multipleMonth]: monthsShown === 2
      })}>
        {children}
      </div>
      {/*</div>*/}
    </div>
  );
});

export default CustomContainer;
